import { render, staticRenderFns } from "./TaxSelectPopup.vue?vue&type=template&id=2501fbbf&"
import script from "./TaxSelectPopup.vue?vue&type=script&lang=js&"
export * from "./TaxSelectPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2501fbbf')) {
      api.createRecord('2501fbbf', component.options)
    } else {
      api.reload('2501fbbf', component.options)
    }
    module.hot.accept("./TaxSelectPopup.vue?vue&type=template&id=2501fbbf&", function () {
      api.rerender('2501fbbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/popup/TaxSelectPopup.vue"
export default component.exports